import dayjs from 'dayjs'
import { getLanguage, LANG_JA } from '@/i18n'

/**
 * 日付をフォーマットする関数
 * 日本語の場合: YYYY年M月D日
 * その他の言語: YYYY/MM/DD
 * @param date フォーマットする日付
 * @returns フォーマットされた日付文字列
 */
export function formatDate(date: Date): string {
  const currentLanguage = getLanguage()
  const dayjsDate = dayjs(date)
  
  if (currentLanguage === LANG_JA) {
    // 日本語の場合: 2024年1月15日
    return dayjsDate.format('YYYY年M月D日')
  } else {
    // その他の言語の場合: 2024/01/15
    return dayjsDate.format('YYYY/MM/DD')
  }
}
